/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Tree_Expand_LabelInputs */



/**
* | output |
* | --- |
* | "Expand" |
*
* @param {Explorer_Tree_Expand_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_tree_expand_label = /** @type {((inputs?: Explorer_Tree_Expand_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Tree_Expand_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Developper")
	if (locale === "de") return /** @type {LocalizedString} */ ("Expandieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Espandere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Расширять")
	if (locale === "es") return /** @type {LocalizedString} */ ("Expandir")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("扩张")
	if (locale === "ja") return /** @type {LocalizedString} */ ("拡大する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बढ़ाना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Expandir")
	return /** @type {LocalizedString} */ ("Expand")
});